import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { PrimaryButton } from '@components/Button/variants';

interface OfferCardProps {
  buttonText: string;
  className?: string;
  description: string;
  highlight?: string;
  id: string;
  offerPrice?: JSX.Element;
  offerTitleClass?: string;
  onButtonClick: () => void;
  title: string;
}

const OfferCard = ({
  buttonText,
  className,
  description,
  highlight,
  id,
  offerPrice: OfferPrice,
  offerTitleClass,
  onButtonClick,
  title,
}: OfferCardProps) => {
  const handleButtonClick = () => {
    onButtonClick();
  };

  return (
    <div
      id={id}
      className={clsx(
        'm-auto flex w-full flex-col items-start justify-between gap-x-16 border border-solid border-grayscale-gray p-16 sm:max-w-[561px] sm:px-48 sm:py-24 md:max-w-[911px] md:flex-row md:items-center lg:max-w-[976px]',
        className
      )}
    >
      <div className="flex flex-col">
        {highlight && (
          <span className="font-suisse-intl-mono text-overline-sm text-grayscale-gray sm:text-caption-md">
            {highlight}
          </span>
        )}
        <div className="mb-8 flex items-center gap-16 sm:gap-24">
          <h2
            className={clsx(
              'm-0 font-suisse-works text-body-md text-black sm:text-headline-sm',
              offerTitleClass
            )}
          >
            {title}
          </h2>
          {OfferPrice}
        </div>

        <p className="my-0 font-suisse-intl text-body-sm font-light text-grayscale-charcoal  sm:text-paragraph">
          {ReactHtmlParser(description)}
        </p>
      </div>
      <PrimaryButton
        as="button"
        size="small"
        className="mt-16 w-full sm:mt-24 sm:w-[270px] md:mt-0"
        onClick={handleButtonClick}
      >
        {buttonText}
      </PrimaryButton>
    </div>
  );
};

export default OfferCard;
